import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import React, {useEffect, useState} from "react"
import {Box, Chip, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {SosPublication} from "../../../../packages/graphql-layer/src";
import routes from "../../../common/constants/routes";
import {usePageContext} from "../../../context/PageContext";
import {getRouteUrl} from "../../../utility/navigationUtil";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import CCOPicture from "../../fundamentals/CCOPicture";
import CCORichText from "../../fundamentals/CCORichText/CCORichText";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import CCODownloadButton from "../../fundamentals/CCODownloadButton";
import C041Video from "../../content/C041Video/C041Video";
import {useCartContext} from "../../../context/CartContext";
import CCOContainer from "../../fundamentals/CCOContainer";
import CCOParagraph from "../../fundamentals/CCOParagraph";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import C039Author from "../../content/C039Author/C039Author";
import CCOH1 from "../../fundamentals/CCOH1";
import C056QueryListCartNotification, {
    handleNotificationOpen
} from "../../content/C056QueryList/C056QueryListCartNotification";
import CCOCircleButton from "../../fundamentals/CCOCircleButton";
import {RichTextElement} from "../../fundamentals/CCORichText/CCORichTextHelper";
import PreviewPropertyHighlighter from "../../preview/PreviewPropertyHighlighter";
import {metaDataProperty} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import P011PublicationAccordion from "./P011PublicationAccordion";
import P011PublicationRelatedContent from "./P011PublicationRelatedContent";
import P011PublicationOtherContent from "./P011PublicationOtherContent";
import P011PublicationBackButton from "./P011PublicationBackButton";


export interface Props {
    sosPublication: SosPublication
    backUri: string
}


function P011Publication(props: Props) {
    const {t} = useTranslation();
    const pageContext = usePageContext();
    const [notificationCardOpen, setNotificationCardOpen] = useState<boolean>(false);
    const subline = (props.sosPublication as any)?.sublineTxt;
    const isH1Activated = !(props.sosPublication as any).publicationSettings?.deactivateH1;
    const isPreview = usePreviewContext().isPreview;
    const hasRelatedContent = props.sosPublication.related && props.sosPublication.related.length > 0 || false;
    const hasOtherContent = props.sosPublication.otherContents && props.sosPublication.otherContents.length > 0 || false;
    const goToCartButton = t('coo_cart_link');
    // used to scroll to video-anchor
    useEffect(() => {
        if (typeof window === "undefined") return;
        let hash = window.location.hash;
        if (!hash) return;
        hash = hash.substring(1);
        const elem = document.getElementById(hash);
        elem?.scrollIntoView({behavior: "smooth", block: "start"});
    }, [(props.sosPublication as any).publicationSettings?.video]);

    const cartContext = useCartContext()

    function order() {
        cartContext.addToCart(props.sosPublication);
        handleNotificationOpen(setNotificationCardOpen);
    }

    function goToCart() {
        window.location.href = getRouteUrl(pageContext.rootUrl, routes.PUBLICATIONS.CART)
    }

    return (<React.Fragment>
        <CCOComponentWrapper id='main' dataCypress={'publicationComponent'} smallmargin={!hasRelatedContent && !hasOtherContent}>
            <C056QueryListCartNotification item={props.sosPublication} open={notificationCardOpen}/>
            {isH1Activated ? <React.Fragment/> : <CCOHeadline metadataId={props.sosPublication.id} headline={props.sosPublication.title}
                                                              propertyName='properties.subline'
                                                              type='componenthead'
                                                              subheadline={subline}/>
            }
            <CCOContainer>
                <CCOH1 metadataId={props.sosPublication.id} propertyName='properties.title' title={props.sosPublication.title} isH1Activated={isH1Activated}></CCOH1>
                {subline ?
                    <Grid item md={12} sx={{display: 'flex', justifyContent: 'center', marginBottom: 3}}><Typography
                        textAlign={'center'} variant={'h6'} {...metaDataProperty(isPreview, 'properties.subline', props.sosPublication.id)}>{subline}</Typography></Grid> : <React.Fragment/>}
                <Grid item md={12} sx={{display: 'flex', justifyContent: 'center'}}>
                    <C039Author publication={props.sosPublication}/>
                </Grid>
                <Grid item md={12} sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}><PreviewPropertyHighlighter propertyName='properties.extDisplayedDate' metadataId={props.sosPublication.id}>{props.sosPublication.extDisplayedDate?.substr(0, 4)}</PreviewPropertyHighlighter></Grid>
            </CCOContainer>

            <CCOComponentWrapper background={'grey'}>
                <CCOContainer background={'grey'}>
                    <React.Fragment key={props.sosPublication.id}>
                        <Grid container columnGap={2}>
                            <Grid item xs={12} md={3} sx={{mx: 2}}>
                                <CCOPicture name={props.sosPublication.picture?.name}
                                            picture={props.sosPublication.picture}
                                            orientation='portrait_ratio3x4' width='780' height='1040'
                                            maxWidth='150'
                                            maxHeight='200'/>
                                {props.sosPublication.new ? <Chip sx={{
                                        position: 'absolute',
                                        top: 10,
                                        right: '30%',
                                    }}
                                                                  label='Neu' color='secondary'/>
                                    : null}
                            </Grid>
                            <Grid item xs={12} md={8}>
                                <Grid item md={12} color='text.secondary'>{props.sosPublication.continfo}</Grid>
                                <CCOParagraph metadataId={props.sosPublication.id} propertyName='properties.publisher'>{props.sosPublication.publisher!}</CCOParagraph>
                                <CCOParagraph metadataId={props.sosPublication.id} propertyName='properties.isbn' label='ISBN:'>{props.sosPublication.isbn!}</CCOParagraph>
                                <CCOParagraph metadataId={props.sosPublication.id} propertyName='properties.issn' label='ISSN:'>{props.sosPublication.issn!}</CCOParagraph>
                                <CCOParagraph metadataId={props.sosPublication.id} propertyName='properties.onlineissn' label='ISSN (online):'>{props.sosPublication.onlineissn!}</CCOParagraph>


                                {props.sosPublication.charge && props.sosPublication.charge != '0,00' ?
                                    <Box sx={{mb: 2}}>Schutzgeb&uuml;hr: {props.sosPublication.charge} &euro; zzgl.
                                        Versandkosten</Box> :
                                    props.sosPublication.ordable ? <CCOParagraph>Kostenfrei</CCOParagraph> : ''}
                                {props.sosPublication.externalLink && props.sosPublication.externalLink.textAsTree ?
                                    <CCORichText metadataId={props.sosPublication.id} propertyName='properties.externalLink'
                                                 textAsTree={props.sosPublication.externalLink!.textAsTree as RichTextElement}/> : ''}
                                {(!props.sosPublication.externalLink || !props.sosPublication.externalLink!.textAsTree) && props.sosPublication.notavailable ?
                                    <CCOParagraph metadataId={props.sosPublication.id} propertyName='properties.notavailable'>{props.sosPublication.notavailable}</CCOParagraph> : ''}


                                <CCODownloadButton download={props.sosPublication.download!}
                                                   propertyName='properties.title'
                                                   downloadTitle={props.sosPublication.title}/>
                                {props.sosPublication.ordable ?
                                    <>
                                        <CCOCircleButton clickFunction={order} label='Bestellen'>
                                            <ShoppingCartOutlinedIcon fontSize={'small'} htmlColor={'white'}/>
                                        </CCOCircleButton>
                                    </> : ''}
                                <CCOCircleButton noWrapText={true} disabled={!cartContext.isCartFilled} clickFunction={goToCart} label={goToCartButton}>
                                    <ShoppingCartCheckoutIcon fontSize={'small'} htmlColor={'white'}/>
                                </CCOCircleButton>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                </CCOContainer>
            </CCOComponentWrapper>
            <span id='watch'></span>
            {(props.sosPublication as any).publicationSettings?.video &&
                <C041Video youtubeUrl={(props.sosPublication as any).publicationSettings?.video}
                           customStyle={{px: {'xs': 0}}}/>
            }
            <CCOContainer>
                <React.Fragment>
                    {props.sosPublication.teaserText ?
                        <Box sx={{mb: 24}}>
                            <CCORichText metadataId={props.sosPublication.id} propertyName='properties.teaserText' textAsTree={props.sosPublication.teaserText!.textAsTree as RichTextElement}/>
                        </Box> : null}
                    <P011PublicationAccordion sosPublication={props.sosPublication}/>
                </React.Fragment>
            </CCOContainer>
        </CCOComponentWrapper>
        {hasRelatedContent && <P011PublicationRelatedContent relatedContents={props.sosPublication.related!}/>}
        {hasOtherContent && <P011PublicationOtherContent otherContents={props.sosPublication.otherContents!}/>}
        <P011PublicationBackButton backUri={props.backUri}/>
    </React.Fragment>);
}

export default P011Publication